import { computed } from 'vue';
import { useInfiniteVueQuery } from '@libs/use';
import { GetBrokerChangeItem, GetBrokerChangeQuery } from '@libs/api-reference';

import * as API from '../requests';
import { SYMBOL_QUERY_KEYS } from '../constants';

export default function useGetBrokerChangeInfiniteQuery() {
  const {
    result,
    reset: resetBrokerChanges,
    isPending: isLoadingBrokerChanges,
    isSuccess: isSuccessGettingBrokerChanges,
    execute: getBrokerChanges,
    ...query
  } = useInfiniteVueQuery<GetBrokerChangeQuery, GetBrokerChangeItem>(
    API.getBrokerChangeRequests,
    {
      key: SYMBOL_QUERY_KEYS.brokerChange,
    }
  );

  const brokerChanges = computed(() => result.value || []);

  return {
    resetBrokerChanges,
    brokerChanges,
    getBrokerChanges,
    isLoadingBrokerChanges,
    isSuccessGettingBrokerChanges,
    ...query,
  };
}
